import { createFileRoute } from "@tanstack/react-router";
import { Camera } from "lucide-react";
import { useSiteSection } from "@/hooks/useSiteContent";
import { SimplePlans } from "@/components/site/SimplePlans";
import { RichText } from "@/components/site/RichText";

export const Route = createFileRoute("/cameras")({
  head: () => ({
    meta: [
      { title: "Câmeras de Segurança — Monitoramento Contato Internet" },
      {
        name: "description",
        content:
          "Planos de câmeras de segurança com instalação, gravação em nuvem e acesso pelo celular a qualquer hora, com suporte local da Contato.",
      },
      { property: "og:title", content: "Câmeras de Segurança — Contato Internet" },
      {
        property: "og:description",
        content: "Monitoramento com gravação em nuvem e acesso pelo app.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: CamerasPage,
});

function CamerasPage() {
  const cameras = useSiteSection("cameras");

  return (
    <>
      <section className="bg-[linear-gradient(110deg,var(--brand-sky-deep),var(--brand-deep))] py-14 text-brand-deep-foreground sm:py-20">
        <div className="mx-auto max-w-7xl px-5">
          <p className="text-[0.7rem] font-extrabold uppercase tracking-[0.2em] text-brand-yellow">
            {cameras.eyebrow}
          </p>
          <h1 className="mt-2 max-w-3xl text-3xl font-extrabold uppercase leading-tight sm:text-4xl">
            {cameras.title}
          </h1>
          <p className="mt-3 max-w-2xl text-sm text-brand-sky sm:text-base">{cameras.subtitle}</p>
        </div>
      </section>

      <section className="bg-background py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-5">
          <RichText
            text={cameras.text}
            className="mx-auto max-w-3xl text-center text-sm leading-relaxed text-muted-foreground sm:text-base"
          />
          <SimplePlans
            items={cameras.items}
            icon={Camera}
            waPrefix="Olá! Quero contratar o plano de câmeras"
          />
        </div>
      </section>
    </>
  );
}
